import React from "react";
import Spark from "@/components/brand/Spark";
import Reveal from "@/components/site/Reveal";

/**
 * Large editorial pull-quote block — used between content-dense sections to give the eye a rest.
 */
export const PullQuote = ({ eyebrow, quote, attribution, tone = "linen", testid }) => {
  const isDark = tone === "espresso";
  const bg = isDark ? "bg-[#2A2422]" : "bg-[#F3EFE7]";
  const textColor = isDark ? "text-[#F3EFE7]" : "text-[#2A2422]";
  const subColor = isDark ? "text-[#F3EFE7]/60" : "text-[#50616B]";
  return (
    <section
      className={`${bg} py-20 md:py-28 relative overflow-hidden`}
      data-testid={testid}
    >
      <div
        className="absolute inset-0 pointer-events-none"
        aria-hidden="true"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 30%, rgba(181,139,66,0.06), transparent 40%), radial-gradient(circle at 85% 70%, rgba(181,139,66,0.04), transparent 50%)",
        }}
      />
      <div className="relative max-w-5xl mx-auto px-6 md:px-10 text-center">
        <Reveal>
          <div className="flex justify-center">
            <Spark size={20} />
          </div>
        </Reveal>
        {eyebrow && (
          <Reveal delay={120}>
            <p className={`eyebrow mt-6 ${isDark ? "text-[#B58B42]" : ""}`}>
              {eyebrow}
            </p>
          </Reveal>
        )}
        <Reveal delay={240}>
          <blockquote
            className={`mt-6 font-display text-3xl sm:text-4xl md:text-[3rem] lg:text-[3.4rem] leading-[1.12] ${textColor}`}
            style={{ fontStyle: "italic" }}
          >
            &ldquo;{quote}&rdquo;
          </blockquote>
        </Reveal>
        {attribution && (
          <Reveal delay={360}>
            <p
              className={`mt-8 font-body text-xs tracking-[0.24em] uppercase ${subColor}`}
            >
              &mdash; {attribution}
            </p>
          </Reveal>
        )}
      </div>
    </section>
  );
};

export default PullQuote;
